import React, { useState, useEffect, useMemo } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  workNumModifyStateRecoil,
  roomWorkNumModifyStateRecoil,
} from '../../atom/ModalAtom';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';
import { refreshDataStateRecoil } from '../../atom/CommonAtom';
import { socketio } from '../../api/socket.api';
import { lineIdStateRecoil } from '../../atom/RoomAtom';
interface RoomWorkNumModiFyProps {
  onListUpdate: () => void;
}

const RoomWorkNumModiFy = ({ onListUpdate }: RoomWorkNumModiFyProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(roomWorkNumModifyStateRecoil);

  const [selectDate, setSelectDate] = useState<string>('');
  const [workNumId, setWorkNumId] = useState<number>(0);
  const [workNum, setWorkNum] = useState<number | null>(null);

  // 방 상세에서 본인 탕수 수정할 때 lineId를 받아올 방법이 없어서 여기는 리코일로 사용
  const [lineIdState, setLineIdState] = useRecoilState(lineIdStateRecoil);

  const getDateWorkNums = async (date: string) => {
    try {
      const response = await roomAPI.getDateWorkNums(
        Number(date.split('-')[0]),
        Number(date.split('-')[1]),
        Number(date.split('-')[2]),
      );
      setWorkNumId(response.data[0].id);
      setWorkNum(response.data[0].cycle);
    } catch {}
  };

  const handleConfirm = async () => {
    if (workNum === null) {
      setError(blankMsg);
      return;
    }

    try {
      await roomAPI.putWorkNum(workNumId, workNum);

      socketio.entry(Number(lineIdState));

      setModalState(false);
      onListUpdate();
      setConfirm('성공적으로 수정되었습니다.');
    } catch {
      setError('탕수 수정에 실패했습니다.');
    }
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    setSelectDate(formattedDate);
    getDateWorkNums(formattedDate);
  }, []);

  return (
    <>
      <InputModal
        title="실 수정"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              탕수
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CustomInputWrap>
              <CS.TextInputType1
                type="text"
                value={workNum !== null ? workNum.toLocaleString() : ''}
                onChange={(e) => {
                  const value = e.target.value
                    .replace(/[^0-9]/g, '')
                    .replace(/,/g, '');
                  setWorkNum(value === '' ? null : Number(value));
                }}
              />
              <div className="btn-wrap">
                <button
                  type="button"
                  className="plus-btn"
                  onClick={() => {
                    if (workNum !== null) {
                      setWorkNum(workNum + 1);
                    }
                  }}
                >
                  <span className="icon-box">
                    <Icon name="PlusIcon" size="100%" color="#fff" />
                  </span>
                </button>
                <button
                  type="button"
                  className="minus-btn"
                  onClick={() => {
                    if (workNum !== null && workNum > 0) {
                      setWorkNum(workNum - 1);
                    }
                  }}
                >
                  <span className="icon-box">
                    <Icon name="MinusIcon" size="100%" color="#fff" />
                  </span>
                </button>
              </div>
            </CustomInputWrap>
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default RoomWorkNumModiFy;

const CustomInputWrap = styled.div`
  width: 100%;
  position: relative;
  input {
    padding-right: 70px;
  }
  .btn-wrap {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    gap: 6px;
    button {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      &.plus-btn {
        background-color: #000;
      }
      &.minus-btn {
        background-color: #aaa;
      }
      .icon-box {
        width: 16px;
        height: 20px;
      }
    }
  }
`;
